//BookShelfListComponents.jsx
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import Tooltip from '../../components/utils/Tooltip';

import MLMButtonWithCount from '../learning/MLMButtonWithCount';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faPlay, faTimes, faBookOpen, faGifts, faTv, faUserFriends, faUserPlus, faUserTie, faUsers, faStop, faComment, faBarChart, faDiagramProject, faUserClock, faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';
import '../learning/styles/BookShelfListComponent.css';
import '../learning/styles/ThinkleticsTables.css';

import MultiLevelReferralTable from '../learning/MultiLevelReferralTable';
import BookEarningCalculator from '../learning/BookEarningCalculator';

import Speech from "speak-tts";
// import adImage from '../../assets/pageimages/bookshelflistad.png';

const SyntraMfgBookShelfListComponent = () => {
    const authState = useSelector(state => state.authReducer);
    const navigate = useNavigate();
    const [fetchData, { loading }] = useFetch();

    const [userId, setUserId] = useState(authState.user._id);
    const [ownerId, setownerId] = useState(authState.user._id);
    const [ownerName, setownerName] = useState(authState.user.name);
    const [myUserCode, setMyUserCode] = useState(authState.user.think5whyscode);
    const [userLevel, setUserLevel] = useState(0);
    const [atLevel, setAtLevel] = useState(0);

    const [bookId, setBookId] = useState(null);
    const [myBooks, setMyBooks] = useState([]);
    const [numberOfBooks, setNumberOfBooks] = useState([]);
    const [readLogs, setReadLogs] = useState([]);
    const [selectedBookId, setSelectedBookId] = useState(null);
    const [selectedReferralBookId, setSelectedReferralBookId] = useState(null);
    const [selectedLangCode, setSelectedLangCode] = useState('en-US');

    const [selectedLog, setSelectedLog] = useState(null);
    const [speechPrefClicked, setSpeechPrefClicked] = useState(false);
    const [speechPref, setSpeechPref] = useState(false);
    const [flyOnTheWall, setFlyOnTheWall] = useState(false);
    const [expandedDates, setExpandedDates] = useState([]);
    const [myReferralsList, setMyReferralsList] = useState([]);
    const [selectedLevel, setSelectedLevel] = useState(0);
    const [myReferralsCount, setMyReferralsCount] = useState(0);
    const [downTheLineGetAllCountClicked, setDownTheLineGetAllCountClicked] = useState(false);
    const [downTheLineGetYTDCountClicked, setDownTheLineGetYTDCountClicked] = useState(false);
    const [downTheLineGetMTDCountClicked, setDownTheLineGetMTDCountClicked] = useState(false);
    const [downTheLineGetLastSevenDaysCountClicked, setDownTheLineGetLastSevenDaysCountClicked] = useState(false);
    const [downTheLineGetTodayCountClicked, setDownTheLineGetTodayCountClicked] = useState(false);
    const [downTheLineGetCustomCountClicked, setDownTheLineGetCustomCountClicked] = useState(false);
    const [isOverlayVisible, setIsOverlayVisible] = useState(false);
    const [selectedThumbBook, setSelectedThumbBook] = useState(null);
    const [newReferEmailId, setNewReferEmailId] = useState('');
    const [newReferContactNumber, setNewReferContactNumber] = useState('');

    const [newReferClicked, setNewReferClicked] = useState(false);
    
    const [downTheLineGetCount, setDownTheLineGetCount] = useState({
        l1: { count: 0, totalCom: 0 },
        l2: { count: 0, totalCom: 0 },
        l3: { count: 0, totalCom: 0 },
        l4: { count: 0, totalCom: 0 },
        l5: { count: 0, totalCom: 0 },
        l6: { count: 0, totalCom: 0 },
        l7: { count: 0, totalCom: 0 },
        l8: { count: 0, totalCom: 0 }
    });
    
    const languageOptions = [
      { code: "en-US", name: "English (United States)" },
      { code: "en-GB", name: "English (United Kingdom)" },
      { code: "en-AU", name: "English (Australia)" },
      { code: "en-CA", name: "English (Canada)" },
      { code: "fr-FR", name: "French (France)" },
      { code: "fr-CA", name: "French (Canada)" },
      { code: "es-ES", name: "Spanish (Spain)" },
      { code: "es-MX", name: "Spanish (Mexico)" },
      { code: "de-DE", name: "German (Germany)" },
      { code: "it-IT", name: "Italian (Italy)" },
      { code: "pt-BR", name: "Portuguese (Brazil)" },
      { code: "pt-PT", name: "Portuguese (Portugal)" },
      { code: "ru-RU", name: "Russian (Russia)" },
      { code: "ja-JP", name: "Japanese (Japan)" },
      { code: "zh-CN", name: "Chinese (Simplified, China)" },
      { code: "zh-TW", name: "Chinese (Traditional, Taiwan)" },
      { code: "ko-KR", name: "Korean (South Korea)" },
      { code: "nl-NL", name: "Dutch (Netherlands)" },
      { code: "sv-SE", name: "Swedish (Sweden)" },
      { code: "no-NO", name: "Norwegian (Norway)" },
      { code: "da-DK", name: "Danish (Denmark)" },
      { code: "fi-FI", name: "Finnish (Finland)" },
      { code: "ar-SA", name: "Arabic (Saudi Arabia)" },
      { code: "hi-IN", name: "Hindi (India)" },
      { code: "bn-BD", name: "Bengali (Bangladesh)" },
      { code: "ta-IN", name: "Tamil (India)" },
      { code: "te-IN", name: "Telugu (India)" },
      { code: "ur-PK", name: "Urdu (Pakistan)" },
      { code: "tr-TR", name: "Turkish (Turkey)" },
      { code: "el-GR", name: "Greek (Greece)" },
    ];
  
    const [showTree, setShowTree] = useState(false);
    const [tree, setTree] = useState(null);
    const [totalUsers, setTotalUsers] = useState(0);
    const [showTable, setShowTable] = useState(false);
    const [postCommentClicked, setPostCommentClicked] = useState(false);
    const [postedComment, setPostedComment] = useState(false);
    const [postedCommentMsg, setPostedCommentMsg] = useState("");
    const [postMyCommentClicked, setPostMyCommentClicked] = useState(false);
    const [commentListFetched, setCommentListFetched] = useState(false);
    const [commentData, setCommentData] = useState([]);
    const [currentPageNumber, setCurrentPageNumber] = useState(1);
    const [bookIdForComment, setBookIdForComment] = useState("");
    const [bookTitleForComment, setBookTitleForComment] = useState("");
    const [bookUserIdForComment, setBookUserIdForComment] = useState("");
    const [userCommentTitle, setUserCommentTitle] = useState("");
    const [userCommentDetails, setUserCommentDetails] = useState("");
    const [isVisibleToAllChecked, setIsVisibleToAllChecked] = useState(false);
    const [postToBeDisabled, setPostToBeDisabled] = useState(false);
    const [readCommentClicked, setReadCommentClicked] = useState(false);
    const [postCloseClicked, setPostCloseClicked] = useState(false);
    const [readCommentCloseClicked, setReadCommentCloseClicked] = useState(false);
    const [isImportantChecked, setIsImportantChecked] = useState(false);
    const [errors, setErrors] = useState();
    const [myPageWalletCount, setMyPageWalletCount] = useState(0);
    const [myAllPageReadCount, setMyAllPageReadCount] = useState(0);
    const [myAllBookPageCount, setMyAllBookPageCount] = useState(0);

// Important TODO
//   const fetchMyPageWalletCount = useCallback(() => {
//     const config = {
//         url: "/pagewallet/count",
//         method: "post",
//         headers: { Authorization: authState.token },
//         data: {userId: userId}
//     };

//   fetchData(config, { showSuccessToast: false })
//       .then(response => {
//           if (response && Array.isArray(response.pageWalletCount)) {
//               setMyPageWalletCount(response.pageWalletCount.length);
//           } else {
//               console.error("Invalid response format: Page Wallet Count not found in response");
//           }
//       })
//       .catch(error => {
//           console.error("Error fetching Page Wallet Datas:", error);
//       });
// }, [authState.token, fetchData]);

// useEffect(() => {
//   if (!authState.isLoggedIn) return;
//   fetchMyPageWalletCount();
// }, [authState.isLoggedIn, fetchMyPageWalletCount]);

const fetchMyBooks = useCallback(() => {
    const config = {
        url: "/mybooks",
        method: "get",
        headers: { Authorization: authState.token },
    };

    fetchData(config, { showSuccessToast: false })
        .then(response => {
            if (response && Array.isArray(response.mybooks)) {
                setMyBooks(response.mybooks);
                setNumberOfBooks(myBooks.length);
            } else {
                console.error("Invalid response format: Book not found in response");
            }
        })
        .catch(error => {
            console.error("Error fetching MyBooks:", error);
        });
  }, [authState.token, fetchData]);


  useEffect(() => {
      if (!authState.isLoggedIn) return;
      fetchMyBooks();
  }, [authState.isLoggedIn, fetchMyBooks]);

    // const imageMap = { Book1Image, Book2Image, RCABookImage, DictaImage, EcommerceImage, ManufacturingImage, GeneralImage, 
    //   NoBookImage, AartiImage, AchheDinImage, BhagwadGeetaImage, BibleImage, BiryaniImage, CandlestickImage, ChildFruitsImage, 
    //   Covid19Image, DiwaliImage, EconomicsFunImage, GKImage, GoodTouchBadTouchImage, GooHabitBadHabitImage, GratitudeImage, 
    //   GSTICSEClass10Image, GSTProfessionalImage, GuruGranthImage, HanumanjiImage, ICSEMathsImage, IndiaNationalAnthemImage, 
    //   IndianFlagImage, IndianMediaImage, IPLImage, KotaFactorImage, KuranImage, LoveImage, MantraImage, MathFormulaImage, 
    //   MomAndBabyImage, NoImageImage, PanchtantraImage, PTImage, PujaImage, PurplePowerImage, ReboundImage, ReelsImage, 
    //   RussiaUkrainWarImage, SanatanImage, SelfishImage, SundarkandImage, SuryatilakImage, T20Image, UddhavGeetaImage, 
    //   TouchHumanBodyMaleAnatomyImage, ChildColorsImage, ChildNumbersEngImage, ChildAlphabetImage, ChildShapesSizesImage, 
    //   ChildBirdsImage, ChildVegetableImage, ChildFlowersImage, KidMobile1Image, KidMobile2Image, ChildVehiclesImage, 
    //   ChildWorldAroundUsImage, ChildKnowYourBodyImage, ChildFarmPetAnimalsImage, ChildUnderwaterAnimalsImage, ChildMySchoolImage, 
    //   ChildJobsPeopleDoImage, ChildWildAnimalsImage, ChildThingsAtHomeImage, ChildFeelingsEmotionsMannersImage, 
    //   ChildFirstWordsImage, ChildFruitSet2Image, ChildPlantImage, ChildHinduGodImage, ChildTreesImage, 
    //   ChildFoodImage, ChildOppositeImage, Think5WhysCollection1Image, Think5WhysCollection2Image, 
    //   ShareMarketWealthMantraCollectionImage, SmartMoneyConceptImage, PurplePowerCollectionImage, 
    //   VOGABGymImage, PTElementsDetailsImage, PTElementsFlashImage, PTTemplatesImage, PTStoryImage, TechBluePrintImage,
    //   MOBookImage 
    // };

    // const getImage = (bookImage) => {
    //     if (imageMap.hasOwnProperty(bookImage)) {
    //         return imageMap[bookImage];
    //     } else {
    //         return NoImageImage;
    //     }
    // };

    const formatDate = (date) => {
        const jsDate = new Date(date);
        const day = jsDate.getDate().toString().padStart(2, '0');
        const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
        const year = jsDate.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const formatDateTime = (date) => {
        const options = {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit',
            hour12: false
        };
        const jsDate = new Date(date);
        const day = jsDate.getDate().toString().padStart(2, '0');
        const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
        const year = jsDate.getFullYear();
        const hours = jsDate.getHours().toString().padStart(2, '0');
        const minutes = jsDate.getMinutes().toString().padStart(2, '0');
        const seconds = jsDate.getSeconds().toString().padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };

    const formatReadTime = (milliseconds) => {
        const totalSeconds = Math.floor(milliseconds / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${minutes}:${seconds}`;
    };

    const handleReadClick = (bookCode, bookMasterId, bookCollectionName, lastPageRead, bookPages, bookIsChildren) => {
      // console.log("Book Code: ",bookCode);
      if( bookCode === "ThinkNoteFlex")  {
        navigate('/readnoteflex', { state: { bookId: bookCode, bookMasterId: bookMasterId, bookCollectionName: bookCollectionName, lastPageRead: lastPageRead, bookPages: bookPages, isChildren: bookIsChildren } });
      } else if ( bookCode === "CAFE") {
        navigate('/readcafebook', { state: { bookId: bookCode, bookMasterId: bookMasterId, bookCollectionName: bookCollectionName, lastPageRead: lastPageRead, bookPages: bookPages, isChildren: bookIsChildren } });
      } else if ( bookCode === "MOBook") {
        navigate('/readopentextbook', { state: { bookId: bookCode, bookMasterId: bookMasterId, bookCollectionName: bookCollectionName, lastPageRead: lastPageRead, bookPages: bookPages, isChildren: bookIsChildren } });
      } 
      else {
        navigate('/readbook', { state: { bookId: bookCode, bookMasterId: bookMasterId, bookCollectionName: bookCollectionName, lastPageRead: lastPageRead, bookPages: bookPages, isChildren: bookIsChildren } });
      }
    };

    const [viewReadLogClicked, setViewReadLogClicked] = useState(false);
    const handleReadLogClick = (bookId) => {
        setSelectedBookId(prev => (prev === bookId ? null : bookId));
        fetchReadingLog(bookId);
    };

    useEffect(() => {
        // Fetch reading log when selected book changes
    }, [selectedBookId]);

    const [viewNotes, setViewNotes] = useState(false);
    const handleViewNotesClick = (bookId) => {
      setSelectedBookId(prev => (prev === bookId ? null : bookId));
      setViewNotes(true);
      if(viewReadLogClicked && readLogs.length<1) {
        fetchReadingLog(bookId);
      }
  };

  const [instantReferralViewClicked,setInstantReferralViewClicked]=useState(false);
  const [myBBList,setMyBBList]=useState(false);
  const [numberOfBB,setNumberOfBB]=useState(0);

  const handleInstantReferralsListClick = (bookId) => {
    setInstantReferralViewClicked(!instantReferralViewClicked);
    if(!instantReferralViewClicked) {
      return;
    }
    if(numberOfBB < 1)
    {
      fetchMyInstantReferral(bookId);
    }
  };

  const fetchMyInstantReferral = useCallback((bookId) => {
    const config = {
        url: "/mybooks/mybblist",
        method: "post",
        headers: { Authorization: authState.token },
        data: {bookId: bookId, bbId: userId}
    };

    fetchData(config, { showSuccessToast: false })
        .then(response => {
            if (response && Array.isArray(response.myBBList)) {
                setMyBBList(response.myBBList);
                setNumberOfBB(myBBList.length);
            } else {
                console.error("Invalid response format: Book not found in response");
            }
        })
        .catch(error => {
            console.error("Error fetching MyBooks:", error);
        });
  }, [authState.token, fetchData]);


  useEffect(() => {
      if (!authState.isLoggedIn) return;
      fetchMyInstantReferral();
  }, [authState.isLoggedIn, fetchMyInstantReferral]);


const [viewBillClicked,setViewBillClicked]=useState(false);
const [myInvoice,setMyInvoice]=useState('');

const handleViewBillClick = (mybookId) => {
  setViewBillClicked(prev => !prev);
  
  // Fetch the invoice if it's not already fetched
  if (!myInvoice) {
    fetchMyInvoice(mybookId);
  }
};

const fetchMyInvoice = useCallback((mybookId) => {
  const config = {
      url: "/myorders/invoice",
      method: "post",
      headers: { Authorization: authState.token },
      data: { bookId: mybookId, userId: userId }
  };

  fetchData(config, { showSuccessToast: false })
      .then(response => {
          if (response && response.myInvoice) {
              // console.log("Invoice response: ", response.myInvoice.invoice);
              setMyInvoice(response.myInvoice);  // Ensure response.myinvoice exists
          } else {
              setMyInvoice('');  // Reset state if no invoice
              console.error("Invalid response format: Invoice not found in response");
          }
      })
      .catch(error => {
          setMyInvoice('');  // Handle errors by resetting state
          console.error("Error fetching invoice:", error);
      });
}, [authState.token, fetchData, userId]);


// useEffect(() => {
//     if (!authState.isLoggedIn) return;
//     fetchMyInvoice();
// }, [authState.isLoggedIn, fetchMyInvoice]);

    const handleFlyOnTheWallClick = (bookId, bookTitle) => {
        navigate('/flyonwall/add', { state: { bookId: bookId, bookTitle: bookTitle, ownerId: ownerId, ownerName: ownerName, flyerOnTheWallId: null, flyerOnTheWallName: null } });
    };

    const handleFlyerOnTheWallListClick = (bookId, bookTitle) => {
        navigate('/flyersonthewall', { state: { bookId: bookId, bookTitle: bookTitle, ownerId: ownerId, ownerName: ownerName, fromPage: "bookShelfList" } });
    };

    const handleDcrClick = (bookId, bookTitle) => {
        navigate('/dcr/add', { state: { bookId: bookId, bookTitle: bookTitle, ownerId: ownerId, ownerName: ownerName, coReaderId: null, coReaderName: null } });
    };

    const handleDcrListClick = (bookId, bookTitle) => {
        navigate('/dcrlist', { state: { bookId: bookId, bookTitle: bookTitle, ownerId: ownerId, ownerName: ownerName, fromPage: "bookShelfList" } });
    };

    const fetchReadingLog = useCallback((bookId) => {
        setBookId(bookId);
        const config = {
            url: "/myreadinglog",
            method: "get",
            headers: { Authorization: authState.token },
            params: { bookId: bookId, userId: userId }
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                if (response && Array.isArray(response)) {
                    setReadLogs(response);
                    setSelectedLog(bookId);
                    setViewReadLogClicked(true);
                } else {
                    console.error("Invalid response format: Book reading log not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching BooksReadingLog:", error);
            });
    }, [authState.token, fetchData, userId, bookId]);

    useEffect(() => {
        fetchReadingLog(bookId);
    }, [fetchReadingLog, setReadLogs]);


    useEffect(() => {

    }, [readLogs, bookId], selectedLog);

    const [showReferralsList, setShowReferralsList] = useState(false);

    const handleMyReferralsListClick = (bookId, myUserCode, userLevel) => {
        setSelectedReferralBookId(prev => (prev === bookId ? null : bookId));
        setShowReferralsList(!showReferralsList);
        fetchMyReferralsList(bookId, myUserCode, userLevel);
    };

    const fetchMyReferralsList = useCallback((bookId, myUserCode, userLevel) => {
        setBookId(bookId);
        setMyUserCode(myUserCode);
        setUserLevel(userLevel);
        const config = {
            url: "/mybooks/myreferralslist",
            method: "post",
            headers: { Authorization: authState.token },
            data: { bookId: bookId, advisorCode: myUserCode, userLevel: userLevel, userCode: myUserCode }
        };

        fetchData(config)
            .then(response => {
                if (response && response.referralsList && Array.isArray(response.referralsList)) {
                    setMyReferralsList(response.referralsList);
                } else {
                    console.error("Invalid response format: Referral List not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching Referral List:", error);
            });
    }, [authState.token, fetchData, userId, bookId]);

    useEffect(() => {
  
    }, [fetchMyReferralsList, setMyReferralsList]);

    const fetchMyReferralsCount = useCallback((bookId, myUserCode, userLevel, atLevel) => {
        setBookId(bookId);
        setMyUserCode(myUserCode);
        setAtLevel(atLevel);
        const config = {
            url: "/mybooks/myreferralscount",
            method: "post",
            headers: { Authorization: authState.token },
            data: { bookId: bookId, advisorCode: myUserCode, userLevel: userLevel, atLevel: atLevel }
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                if (response) {
                    setMyReferralsCount(response.referralsCount);
                    setSelectedLevel(atLevel);
                } else {
                    console.error("Invalid response format: Referral Count not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching Referral Count:", error);
            });
    }, [authState.token, fetchData, userId, bookId, myUserCode, userLevel, atLevel]);

    useEffect(() => {

    }, [fetchMyReferralsCount, setMyReferralsCount]);


    useEffect(() => {
        //
    }, [myReferralsCount, bookId], myUserCode, atLevel, selectedLevel);

    const dateRangeType='A';
    const [fromDate, setFromDate] = useState(new Date().toISOString().split('T')[0]);
    const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);
    const [customFromDate, setCustomFromDate] = useState(new Date().toISOString().split('T')[0]);
    const [customToDate, setCustomToDate] = useState(new Date().toISOString().split('T')[0]);

    const handleChange = (e) => {
      const { name, value } = e.target;
      if (name === 'newReferContactNumber') {
        setNewReferContactNumber(value);
      } else if (name === 'newReferEmailId') {
        setNewReferEmailId(value);
      }
    };

    const fieldError = (fieldName) => {
      if (fieldName === 'newReferEmailId' && !newReferEmailId.includes('@')) {
        return <p className="text-red-500">Please enter a valid email address</p>;
      }
      if (fieldName === 'newReferContactNumber' && newReferContactNumber.length < 10) {
        return <p className="text-red-500">Please enter a valid WhatsApp number</p>;
      }
      return null; // No error
    };

    const handleNewRefer = () => {
      setNewReferClicked(true);
    };

    const handleNewReferSent = (bookId, newReferContactNumber, newReferEmailId) => {
      handleWhatsAppClick(bookId, newReferContactNumber, newReferEmailId);
    };

    // WhatsApp method for referral
    const handleWhatsAppClick = (bookId, newReferContactNumber, newReferEmailId) => {
      const whatsappUrl = `https://wa.me/${newReferContactNumber}?text=Check%20out%20this%20book!%20Book%20ID:%20${bookId}%20Email:%20${newReferEmailId}`;
      window.open(whatsappUrl, '_blank');
    };


    const handleDownTheLineGetAllCount = (selectedBookId) => {
        setDownTheLineGetAllCountClicked(true);
        const fromDate = new Date().toISOString().split('T')[0];;
        const toDate = new Date().toISOString().split('T')[0];;
        fetchDownTheLineGetCount(selectedBookId, myUserCode, userId, 'A', fromDate, toDate);
    };

    const handleDownTheLineGetYTDCount = (selectedBookId) => {
        setDownTheLineGetYTDCountClicked(true);
        // Calculate toDate (yesterday's date)
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        const toDate = yesterday.toISOString().split('T')[0]; // Example: "2024-07-10"

        const firstDateOfYear = new Date(today.getFullYear(), 0, 1); // Month is 0-based, so 0 represents January
        const fromDate = firstDateOfYear.toISOString().split('T')[0]; // Example: "2024-01-01"
        fetchDownTheLineGetCount(selectedBookId, myUserCode, userId, 'Y', fromDate, toDate);
    };

    const handleDownTheLineGetMTDCount = (selectedBookId) => {
        setDownTheLineGetMTDCountClicked(true);
        // Calculate toDate (yesterday's date)
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        const toDate = yesterday.toISOString().split('T')[0]; // Example: "2024-07-10"

        const firstDateOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        const fromDate = firstDateOfMonth.toISOString().split('T')[0]; // Example: "2024-07-01"
        fetchDownTheLineGetCount(selectedBookId, myUserCode, userId, 'M', fromDate, toDate);
    };

    const handleDownTheLineGetLastSevenDaysCount = (selectedBookId) => {
        setDownTheLineGetLastSevenDaysCountClicked(true);
        // Calculate toDate (yesterday's date)
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        const toDate = yesterday.toISOString().split('T')[0]; 

        // Calculate fromDate (6 days before toDate)
        const sixDaysAgo = new Date(yesterday);
        sixDaysAgo.setDate(sixDaysAgo.getDate() - 6);
        const fromDate = sixDaysAgo.toISOString().split('T')[0]; 
        fetchDownTheLineGetCount(selectedBookId, myUserCode, userId, 'W', fromDate, toDate);
    };

    const handleDownTheLineGetTodayCount = (selectedBookId) => {
        setDownTheLineGetTodayCountClicked(true);
        const fromDate = new Date().toISOString().split('T')[0];
        const toDate = new Date().toISOString().split('T')[0];
        fetchDownTheLineGetCount(selectedBookId, myUserCode, userId, 'T', fromDate, toDate);
    };

    const handleDownTheLineGetCustomCount = (selectedBookId) => {
        setDownTheLineGetCustomCountClicked(true);
        const fromDate = customFromDate;
        const toDate = customToDate;
        fetchDownTheLineGetCount(selectedBookId, myUserCode, userId, 'C', fromDate, toDate);
    };

    const fetchDownTheLineGetCount = useCallback((selectedBookId, myUserCode, myUserId, dateRangeType, fromDate, toDate) => {
        setBookId(selectedBookId);
        setMyUserCode(myUserCode);
        if (!selectedBookId || !myUserCode || !myUserId || !dateRangeType || !fromDate || !toDate) {
            return;
        }
        const config = {
            url: "/mlmchart/downthelinecount",
            method: "post",
            headers: { Authorization: authState.token },
            data: { 
                bookId: selectedBookId, 
                userCode: myUserCode, 
                userId: myUserId, 
                dateRangeType: dateRangeType, 
                fromDate: fromDate,
                toDate: toDate 
            }
        };
        // console.log("Request Payload:", { selectedBookId, myUserCode, myUserId, dateRangeType, fromDate, toDate }); // Log the payload
        fetchData(config, { showSuccessToast: false })
            .then(response => {
                // console.log("response from referral list endpoint: ", response);

                if (response && response.referralsCount) {
                    setDownTheLineGetCount(response.referralsCount);
                } else {
                    console.error("Invalid response format: Down The Line Referral Count not found in response");
                    setDownTheLineGetCount({
                        l1: { count: 0, totalCom: 0 },
                        l2: { count: 0, totalCom: 0 },
                        l3: { count: 0, totalCom: 0 },
                        l4: { count: 0, totalCom: 0 },
                        l5: { count: 0, totalCom: 0 },
                        l6: { count: 0, totalCom: 0 },
                        l7: { count: 0, totalCom: 0 },
                        l8: { count: 0, totalCom: 0 }
                    });
                }
            })
            .catch(error => {
                console.error("Error fetching Down The Line  Referral Count:", error);
                setDownTheLineGetCount({
                    l1: { count: 0, totalCom: 0 },
                    l2: { count: 0, totalCom: 0 },
                    l3: { count: 0, totalCom: 0 },
                    l4: { count: 0, totalCom: 0 },
                    l5: { count: 0, totalCom: 0 },
                    l6: { count: 0, totalCom: 0 },
                    l7: { count: 0, totalCom: 0 },
                    l8: { count: 0, totalCom: 0 }
                });
            });
    }, [authState.token, fetchData]);

    useEffect(() => {
            // fetchDownTheLineGetCount(bookId, myUserCode, userId, dateRangeType, fromDate, toDate); 
    }, [setDownTheLineGetCount, fetchDownTheLineGetCount]);

    const sortedBooks = myBooks.sort((a, b) => {
        const dateA = new Date(a.purchaseDate);
        const dateB = new Date(b.purchaseDate);
        return dateB - dateA;
    });


    const sortedLog = readLogs.sort((a, b) => {
        const dateA = new Date(a.dateRead);
        const dateB = new Date(b.dateRead);
        return dateB - dateA;
    });

    const sortedPages = readLogs.sort((a, b) => {
      const pageA = new Date(a.pageNumber);
      const pageB = new Date(b.pageNumber);
      return pageA - pageB;
  });

    const toggleDateExpansion = (date) => {
        if (expandedDates.includes(date)) {
            setExpandedDates(expandedDates.filter(item => item !== date));
        } else {
            setExpandedDates([...expandedDates, date]);
        }
    };

    const logsByDate = readLogs.reduce((acc, log) => {
        const date = log.dateRead.split('T')[0];
        if (!acc[date]) {
            acc[date] = [];
        }
        acc[date].push(log);
        return acc;
    }, {});

  //   const logsByPageNumber = readLogs.reduce((acc, log) => {
  //     const pgn = log.pageNumber;
  //     if (!acc[date]) {
  //         acc[date] = [];
  //     }
  //     acc[date].push(log);
  //     return acc;
  // }, {});

  // Sort dates in descending order
  const sortedLogsByDate = Object.keys(logsByDate)
      .sort((a, b) => new Date(b) - new Date(a))
      .reduce((acc, date) => {
          acc[date] = logsByDate[date];
          return acc;
      }, {});

      // console.log("sortedLogsByDate ",sortedLogsByDate);

      const groupedReadLogs = readLogs.reduce((acc, log) => {
        const existingLog = acc.find(item => item.pageNumber === log.pageNumber);
    
        if (existingLog) {
            existingLog.pageCount += 1;
            existingLog.totalMilliseconds += log.readTimeInMiliseconds;
            
            // Ensure uniqueness while keeping the array structure
            if (!existingLog.readingRemarks.includes(log.readingRemarks)) {
                existingLog.readingRemarks.push(log.readingRemarks);
            }
        } else {
            acc.push({
                pageNumber: log.pageNumber,
                pageCount: 1,
                totalMilliseconds: log.readTimeInMiliseconds,
                readingRemarks: [log.readingRemarks], // Start with the first unique remark
            });
        }
    
        return acc;
    }, []);
    

    const totalCount = Object.values(downTheLineGetCount).reduce((sum, level) => sum + level.count, 0);
    const totalCommission = Object.values(downTheLineGetCount).reduce((sum, level) => sum + parseFloat(level.totalCom), 0);

    const [showReferrals, setShowReferrals] = useState(false);

    const toggleReferralsList = () => {
      setShowReferrals(!showReferrals);
    };

  const [viewCommentClick, setViewCommentClick] = useState(false);
  const [viewCommentClickMsg, setViewCommentClickMsg] = useState('');
  // const handleViewComments = (bookId, pageNumber, userId) => {
  //   setViewCommentClick(true);
  //   setViewCommentClickMsg("You can view your annotations & other's comments for this page! We will get back to you soon with this feature.");
  //   fetchReadCommentByPageNumber()
  // }


  // const [viewComment, setViewComment] = useState(false);
  const handleViewComments = (selectedBookId, bookOwnerId, bookPageNumber) => {
    // setViewComment(true);
    setIsOverlayVisible(true);
    // setPostCommentClicked(false);
    fetchReadCommentByPageNumber(selectedBookId, bookOwnerId, bookPageNumber);
  }

  const handleCloseOverlay = () => {
    setIsOverlayVisible(false);
  };
  

  //Read Comments List
  const fetchReadCommentByPageNumber = useCallback((selectedBookId, bookOwnerId, bookPageNumber) => {
    const config = {
      url: "/myreadingnotes/notesbybookpage",
      method: "post",
      headers: { Authorization: authState.token },
      data: {
        bookId: selectedBookId,
        userId: bookOwnerId,
        pageNumber: bookPageNumber
      },
    };
    // console.log("Read Comments config to server: ", config);

    fetchData(config, { showSuccessToast: false })
      .then((response) => {
        // console.log("Read Comments Response:", response);
        if (response && response.status) {
          setCommentData(response.notes);
          // console.log("setCommentData ", response.notes); // Log response.notes
        } else {
          console.error("Read Comments data not found in response");
        }
      })
      .catch((error) => {
        console.error("Error fetching Read Comments data:", error);
      });
  }, [authState.token, fetchData]);


  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchReadCommentByPageNumber();
  }, [authState.isLoggedIn, fetchReadCommentByPageNumber]);

  const sortedCommentData = [...commentData].sort(
    (a, b) => new Date(b.dateCreated) - new Date(a.dateCreated)
  );

  const handlePostClose = () => {
    setPostCloseClicked(true);
    setPostCommentClicked(false);
    setPostToBeDisabled(true);
  };

  const handleReadCommentClose = () => {
    setReadCommentClicked(false);
    setReadCommentCloseClicked(true);
  };

  const gotoRCA = (bookIdForComment, bookTitleForComment, userIdForComment, pageNumber ) => {
    // console.log("I am inside gotoRCA()");
    navigate("/rcas/add");
  };

  const [isListenNotesClicked, setIsListenNotesClicked] = useState(false);
  
  const listenNotesClicked = (mynotestext) => {
    setIsListenNotesClicked(true);
    speech.cancel();
    toggleSpeechNotes(mynotestext);
  }

  const [isNotesSpeaking, setIsNotesSpeaking] = useState(false);
  const speech = new Speech();

  const toggleSpeechNotes = (mynotestext) => {
    // console.log("my notes text ",mynotestext);

    if (isNotesSpeaking) {
      speech.cancel();
      setIsNotesSpeaking(false);
    } else {
      setIsNotesSpeaking(true);
      speech.setRate(1.0);
      speech.setPitch(2.0);
      speech.setVolume(1.0);
      speech.setLanguage(selectedLangCode);
      speech.speak({ text: mynotestext });
    }
  };

  useEffect(() => {
    return () => {
      if (isNotesSpeaking) {
        speech.cancel();
        setIsNotesSpeaking(false);
      }
    };
  }, [isNotesSpeaking]);

const handleViewGraphTimeLineClick = (graphData) => {
    navigate("/bigdata-book-readlog-timeline", { state: { graphData: graphData } });
};

const handleViewGraphPageReadCountClick = (graphData) => {
  navigate("/bigdata-book-readlog-pageread", { state: { graphData: graphData } });
};

const scrollToDetail = (bookCode) => {
  const detailElement = document.getElementById(`book-detail-${bookCode}`);
  if (detailElement) {
    detailElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  } else {
    console.error(`Detail section for bookCode ${bookCode} not found.`);
  }
};

  return (
    <div className="book-list flex flex-col justify-center">
      <div className="ml-2 mr-2 page-content flex flex-col justify-center items-center">
        <div>
          {myBooks.length < 1 ? (
            <div className="text-yellow-500 text-4xl mt-4">
              <p>Your Bookshelf is Empty!!</p>
            </div>
          ) : (
            <div>
              <p className="text-white text-xl">Your BookShelf has {myBooks.length} Titles</p>
            </div>
          )}
        </div>
      </div>

      <div className="thumb-grid-container">
        {sortedBooks.map((book, index) => (
          <div
            key={book.bookCode}
            className="thumb-book-item"
            onClick={() => scrollToDetail(book.bookCode)}
            style={{ cursor: 'pointer' }}
          >
            <img 
                src={`/api/bookworldthumb/${book.bookImage}.png`}
                alt={"No Image " + book.bookTitle} 
                className="thumb-book-image"
            />
            <h2 className="thumb-book-title">
              {book.isCollection ? <span className="text-yellow-200">Collection: </span> : ""}
              {book.bookTitle}
            </h2>
          </div>
        ))}
      </div>
      {sortedBooks.map((book, index) => (
        <div key={book.bookCode} id={`book-detail-${book.bookCode}`} className="book-item">
          <div>
            <h2 className="text-orange-600">Title - # {index + 1}</h2>
          </div>
          {book.isCollection && (
          <div className="details-container">
            <h2 className="book-title text-green-700">
              This is part of{" "}
              <span className="text-green-700">
                {book.collectionTitle} Collection of Books
              </span>
            </h2>
          </div>
          )}
          {book.isCollection === true && (
            <div>
              <p className="text-orange-600 ">
                This is a collection. You can't read a collection directly. In
                stead read the books of this collection available in your
                BookShelf.
              </p>
            </div>
          )}
          <div className="thumb-book-image-container">
            <img 
                src={`/api/bookworldthumb/${book.bookImage}.png`}
                alt={"No Image " + book.bookTitle} 
                className="thumb-book-image"
            />
          </div>
          <div className="details-container mt-2">
            <p className="book-title">{book.bookTitle}</p>
          </div>
          {book.isSampleBuy && (
            <div>
              <p className="bg-yellow-300 text-black">
                This is Sample. Limited access is applied on this.
              </p>
            </div>
          )}
          <div className="mt-2 mb-2 w-full">
            <div className="flex justify-center mt-2">
              <div className="tooltip-container w-20">
                <button
                  className="ml-4 px-2 py-1 text-white rounded bg-green-500"
                  // disabled={book.isCollection || book.isDictaBook}
                  disabled={book.isCollection}
                  onClick={() =>
                    handleReadClick(
                      book.bookCode,
                      book.bookId,
                      book.bookCollectionName,
                      book.lastPageRead,
                      book.bookPages,
                      book.isChildren
                    )
                  }
                  style={{ maxWidth: "150px" }}
                >
                  <FontAwesomeIcon icon={faBookOpen} />
                </button>
                <span className="tooltip">Read</span>
              </div>
              <div className="tooltip-container ml-4 w-20">
                <button
                  className="ml-2 py-1 text-white rounded bg-green-500"
                  disabled={book.isCollection}
                  onClick={() => handleReadLogClick(book.bookId)}
                  style={{ maxWidth: "160px" }}
                >
                  <FontAwesomeIcon icon={faBook} />
                </button>
                <span className="tooltip">View Read Log</span>
              </div>
              <div className="tooltip-container ml-4 w-20">
                <button
                  className="ml-2 py-1 text-white rounded bg-green-500"
                  disabled={book.isCollection}
                  onClick={() => handleViewNotesClick(book.bookId)}
                  style={{ maxWidth: "160px" }}
                >
                  <FontAwesomeIcon icon={faComment} />
                </button>
                <span className="tooltip">View / Listen Notes</span>
              </div>
              <div className="tooltip-container ml-4 w-20">
                  <button
                    className="ml-2 py-1 text-white rounded bg-green-500"
                    onClick={() => handleViewGraphTimeLineClick(logsByDate)}
                    style={{ maxWidth: "160px" }}
                  >
                    <FontAwesomeIcon icon={faBarChart} />
                  </button>
                  <span className="tooltip">View Graph</span>
              </div>
            </div>
            {selectedBookId === book.bookId &&
              Object.keys(logsByDate).length > 0 &&
              book && (
                <div className='text-sm w-full'>
                  <div>
                    <p className='text-black'>
                      <span className="text-green-600 mr-2">
                        Page Accessed {readLogs.length}
                      </span>
                      times! 
                      <span className='text-blue-700 ml-4'>
                        Your Paid Page Access Limit is {book.paidReads}!
                      </span>
                    </p>
                    { readLogs.length > (book.paidReads + myPageWalletCount) && (
                      <>
                        <p>Your Page Read Limit has Reached
                          <span className='ml-2'>
                            <Link to="/genai-price-List" className='text-orange-300'>
                              Buy Topup Subscription
                            </Link>
                          </span>
                        </p>
                      </>
                    )}
                  </div>
                  <div>
                    <p className="text-sm">Time Spent in min:sec (less than 0 seconds will be shown as 0:0)</p>
                  </div>
                  {/* <div className="tooltip-container ml-4 w-20">
                    <button
                      className="ml-2 py-1 text-white rounded bg-green-500"
                      onClick={() => handleViewGraphTimeLineClick(logsByDate)}
                      style={{ maxWidth: "160px" }}
                    >
                      <FontAwesomeIcon icon={faBarChart} />
                    </button>
                    <span className="tooltip">View Graph</span>
                  </div> */}
                  <div className="text-white bg-slate-800 flex w-full text-lg">
                      <p>Page Read Log</p>
                  </div>
                  <div className="text-white bg-slate-700 flex w-full text-sm">
                    <div
                      className="text-sm"
                      style={{
                        width: "30%",
                        border: "1px solid white",
                        textAlign: "left",
                        padding: "0.25rem", 
                      }}
                    >
                      Date Read
                    </div>
                    <div
                      className="text-sm"
                      style={{
                        width: "50%",
                        border: "1px solid white",
                        padding: "0.25rem", 
                      }}
                    >
                      Page
                    </div>
                    <div
                      className="text-sm"
                      style={{
                        width: "20%",
                        border: "1px solid white",
                        padding: "0.25rem", 
                      }}
                    >
                      Time Spent
                    </div>
                  </div>
                  <div className="text-black bg-blue-200 w-full text-sm">
                    {Object.entries(logsByDate).map(([date, logs]) => (
                      <div key={date}>
                        <div
                          className="text-yellow-600 text-sm"
                          onClick={() => toggleDateExpansion(date)}
                          style={{ textAlign: "left" }}
                        >
                          <span>
                            {expandedDates.includes(date) ? "-" : "+"}
                          </span>{" "}
                          {formatDate(date)}
                        </div>
                        {expandedDates.includes(date) && (
                          <div className='text-sm mt-2'>
                            {logs.map((log, index) => (
                              <div
                                key={index}
                                className="flex justify-start text-sm"
                              >
                                <div
                                  className='text-sm px-2'
                                  style={{
                                    width: "30%",
                                    marginRight: "2px",
                                    border: "1px solid white",
                                  }}
                                >
                                  {formatDateTime(log.dateRead)}
                                </div>
                                <div
                                  style={{
                                    width: "50%",
                                    marginRight: "2px",
                                    border: "1px solid white",
                                  }}
                                  className='px-2'
                                >
                                  {log.readingMode==='TV' && ( <FontAwesomeIcon className="text-sm mr-2" icon={faTv}/>)}
                                  {log.readingRemarks}
                                </div>
                                <div
                                  style={{
                                    width: "20%",
                                    border: "1px solid white",
                                  }}
                                  className='px-2'
                                >
                                  {formatReadTime(log.readTimeInMiliseconds)}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                  { viewNotes && (
                    <>
                      <div className="text-white bg-slate-800 flex w-full text-lg mt-4">
                          <p>Pages Access Summary, Notes & RCA</p>
                      </div>
                      <div className="text-white bg-slate-700 px-2 flex w-full text-sm">
                        <div
                          className="text-sm"
                          style={{
                            width: "40%",
                            border: "1px solid white",
                            padding: "0.25rem", 
                          }}
                        >
                          Page
                        </div>
                        <div
                          className="text-sm"
                          style={{
                            width: "15%",
                            border: "1px solid white",
                            padding: "0.25rem", 
                          }}
                        >
                          Read Count
                        </div>
                        <div
                          className="text-sm"
                          style={{
                            width: "15%",
                            border: "1px solid white",
                            padding: "0.25rem", 
                          }}
                        >
                          Time Spent
                        </div>
                        <div
                          className="text-sm"
                          style={{
                            width: "15%",
                            border: "1px solid white",
                            padding: "0.25rem", 
                          }}
                        >
                          Notes
                        </div> 
                        <div
                          className="text-sm"
                          style={{
                            width: "15%",
                            border: "1px solid white",
                            padding: "0.25rem", 
                          }}
                        >
                          RCA
                        </div>
                      </div>
                      <div className="text-black bg-blue-200 px-2 w-full text-sm">
                        {groupedReadLogs.map((group, index) => (
                          <div key={index} className="flex justify-start text-sm">
                            <div
                              style={{
                                width: "40%",
                                marginRight: "2px",
                                border: "1px solid white",
                              }}
                              className='px-2'
                            >
                              {group.readingMode==='TV' && ( <FontAwesomeIcon className="text-sm mr-2" icon={faTv}/>)}
                              {group.readingRemarks}
                            </div>
                            <div
                              style={{
                                width: "15%",
                                border: "1px solid white",
                              }}
                              className='px-2'                              
                            >
                              {group.readingRemarks.length}
                            </div>
                            <div
                              style={{
                                width: "15%",
                                border: "1px solid white",
                              }}
                              className='px-2'
                            >
                              {formatReadTime(group.totalMilliseconds)}
                            </div>
                            <div
                              style={{
                                width: "15%",
                                border: "1px solid white",
                              }}
                            >
                              <Tooltip text={"View Notes/Comments"} position={"top"}>
                                <span
                                  className="mr-1 text-blue-500 cursor-pointer px-2"
                                  onClick={() =>
                                    handleViewComments(
                                      book.bookId,
                                      book.userId,
                                      group.pageNumber
                                    )
                                  }
                                >
                                  <i className="fa-solid fa-comments"></i>
                                </span>
                              </Tooltip>
                            </div>
                            <div
                              style={{
                                width: "15%",
                                border: "1px solid white",
                              }}
                            >
                              <Tooltip text={"RCA"} position={"top"}>
                                <span
                                  className="ml-1 mr-1 text-blue-500 cursor-pointer px-2"
                                  onClick={() =>
                                    gotoRCA(
                                      book.bookId,
                                      book.bookTitle,
                                      book.ownerId,
                                      group.pageNumber
                                    )
                                  }
                                >
                                  <i className="fa-solid fa-fish"></i>
                                </span>
                              </Tooltip>
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                  {isOverlayVisible && (
                    <>
                    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-[1000[">
                      <div className="bg-black p-6 rounded-lg shadow-lg w-full max-w-4xl">
                        <button
                          className="absolute top-2 right-2 text-red-500"
                          onClick={() => handleCloseOverlay(false)}
                        >
                          <FontAwesomeIcon icon={faTimes} />Close
                        </button>
                        {sortedCommentData.length > 0 ? (
                          sortedCommentData.map((commentItem, commentIndex) => (
                            <div
                              key={commentIndex}
                              className="mb-6 p-6 bg-white shadow-xl rounded-lg border border-gray-200 hover:shadow-2xl transition-shadow duration-300"
                            >
                              <h4 className="text-2xl font-bold text-gray-900 mb-2">
                                {commentItem.notesType}
                              </h4>
                              <p className="text-lg font-semibold text-blue-700 mb-2">
                                {commentItem.notesTitle}
                              </p>
                              <p className="text-base text-gray-700 mb-4">
                                <strong>Details:</strong>
                                <br />
                                {commentItem.notesText}
                              </p>
                              <div className="flex justify-between items-center">
                                <p className="text-sm text-gray-600">
                                  <strong>Is Important: </strong>
                                  {commentItem.isImportant ? (
                                    <span className="text-red-600 font-semibold">Yes</span>
                                  ) : (
                                    "No"
                                  )}
                                </p>
                                <p className="text-sm text-gray-600">
                                  <strong>By: </strong>
                                  {commentItem.notesBy}
                                </p>
                              </div>
                              <p className="text-right text-sm text-gray-500 mt-4">
                                <strong>Date: </strong>
                                {formatDateTime(commentItem.dateCreated)}
                              </p>
                              <div className="flex justify-end items-center mt-4">
                                <select
                                  value={selectedLangCode}
                                  onChange={(e) => setSelectedLangCode(e.target.value)}
                                  className="ml-4 p-2 h-8 border border-gray-300 rounded"
                                >
                                  {languageOptions.map((option) => (
                                    <option key={option.code} value={option.code}>
                                      {option.name}
                                    </option>
                                  ))}
                                </select>
                                <button
                                  className="ml-1 mt-2 mr-4 max-w-8 max-h-8 bg-green-600 text-white"
                                  onClick={() => listenNotesClicked(commentItem.notesText)}
                                >
                                  {isNotesSpeaking ? (
                                    <FontAwesomeIcon icon={faStop} />
                                  ) : (
                                    <FontAwesomeIcon icon={faPlay} />
                                  )}
                                </button>
                              </div>
                            </div>
                          ))
                        ) : (
                          <>
                          <div className="mt-20 mb-20 flex flex-col justify-center text-center">
                            <p className="text-lg font-medium text-orange-500">
                              There are no Notes / Comments / Remarks for this Page!
                            </p>
                            <button
                              className="absolute top-2 right-2 text-red-500"
                              onClick={() => handleCloseOverlay(false)}
                            >
                              <FontAwesomeIcon icon={faTimes} />Close
                            </button>
                          </div>
                          </>
                        )}
                      </div>
                    </div>
                    </>
                  )}
                  {viewCommentClick && (
                    <div className="flex justify-center text-yellow-600 mb-4">
                      <p>{viewCommentClickMsg}</p>
                    </div>
                  )}
                </div>
              )}
            <div>
              <p className="book-author text-blue-500">
                Pages: {book.bookPages}
              </p>
              <p className="book-author text-blue-500">
                Author: {book.bookAuthor}
              </p>
              <p className="book-author text-purple-700">
                In BookShelf Since{" "}
                <strong>{formatDateTime(book.purchaseDate)}</strong>
              </p>
              {book.isCollection === false && (
                <>
                  <p
                    className={`book-author ${
                      book.lastReadingDate
                        ? "text-purple-700"
                        : "text-brown-500"
                    }`}
                  >
                    {book.lastReadingDate ? (
                      <>
                        Last Page Read: <strong>{book.lastPageRead}</strong>{" "}
                        On{" "}
                        <strong>
                          {formatDateTime(book.lastReadingDate)}
                        </strong>
                      </>
                    ) : (
                      <strong className="text-orange-500">
                        Not Read Yet
                      </strong>
                    )}
                  </p>
                </>
              )}
              {book.isGifted === 1 && (
                <div className="details-container mt-4">
                  <h2 className="text-lime-500 text-lg mb-4">
                    <FontAwesomeIcon
                      icon={faGifts}
                      className="text-red-500 text-4xl"
                    />
                  </h2>
                  <p className="text-yellow-400">
                    Gifted By : <strong>{book.gifterName}</strong>
                  </p>
                  <p className="text-purple-600">
                    <strong>{book.giftMessage}</strong>
                  </p>
                  <p className="text-green-700">{book.gifterSignatureLine}</p>
                  <p className="book-author text-blue-500">{book.gifFor}</p>
                  <p className="book-author text-gray-800">
                    Gifted on : {formatDate(book.purchaseDate)}
                  </p>
                </div>
              )}
            </div>
          </div>
          <div className="flex details-container mt-2 justify-center">
            <div className="tooltip-container w-20">
              <button
                className="ml-2 py-1 text-white rounded bg-purple-800"
                onClick={() =>
                  handleInstantReferralsListClick(book.bookId)
                }
              >
                <FontAwesomeIcon icon={faUserClock} />
              </button>
              <span className="tooltip">My Instant Referrals</span>
            </div>

            <div className="tooltip-container w-20">
              <button
                className="ml-2 py-1 text-white rounded bg-purple-800"
                onClick={() => handleViewBillClick(book.bookId)}
              >
                <FontAwesomeIcon icon={faFileInvoiceDollar} />
              </button>
              <span className="tooltip">
                Bill cum Receipt
              </span>
            </div>
          </div>
          {instantReferralViewClicked && (
            <div className="p-4">
              <p className="text-lg font-semibold text-blue-800 mb-4">My Instant Referral List for the Book</p>
              <div className="overflow-x-auto">
                <table className="min-w-full bg-white border border-gray-300 shadow-md rounded-lg">
                  <thead>
                    <tr className="bg-blue-100">
                      <th className="px-4 py-2 text-left text-white">Username</th>
                      <th className="px-4 py-2 text-left text-white">Referral Bonus</th>
                      <th className="px-4 py-2 text-left text-white">Purchase Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {myBBList.map((bblist, index) => (
                      <tr key={index} className="border-t">
                        <td className="px-4 py-2 text-black">{bblist.userName}</td>
                        <td className="px-4 py-2 text-black">{(bblist.paymentAmount * 0.13).toFixed(2)}</td>
                        <td className="px-4 py-2 text-black">{formatDateTime(bblist.purchaseDate)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          { viewBillClicked && (
            <div className="p-4">
              <p className="text-lg font-semibold text-blue-800 mb-4">My Bill cum Receipt</p>
              {!myInvoice.invoice ? (
                <div>
                  <p className='text-orange-500 text-lg'>Invoice Not Found!!</p>
                </div>
              ) : (
                <div
                    className="page-content ml-2 mr-2 flex items-start"
                    style={{ minHeight: "100%" }}
                    dangerouslySetInnerHTML={{ __html: myInvoice.invoice }}
                />
              )}
            </div>
          )}
          <div className="flex details-container mt-2 justify-center">
            <div className="tooltip-container w-20">
              <button
                className="ml-2 py-1 text-white rounded bg-purple-800"
                disabled={book.isCollection}
                onClick={() =>
                  handleFlyOnTheWallClick(book.bookId, book.bookTitle)
                }
              >
                <FontAwesomeIcon icon={faUserPlus} />
              </button>
              <span className="tooltip">Allow Fly On The Wall</span>
            </div>

            <div className="tooltip-container w-20">
              <button
                className="ml-2 py-1 text-white rounded bg-purple-800"
                disabled={book.isCollection}
                onClick={() =>
                  handleFlyerOnTheWallListClick(book.bookId, book.bookTitle)
                }
              >
                <FontAwesomeIcon icon={faUserTie} />
              </button>
              <span className="tooltip">
                List of My Flyers On The Wall for This Book
              </span>
            </div>

            <div className="tooltip-container w-20">
              <button
                className="py-1 text-white rounded bg-purple-800"
                // disabled={book.isCollection}
                disabled={true}
                onClick={() => handleDcrClick(book.bookId, book.bookTitle)}
              >
                <FontAwesomeIcon icon={faUserFriends} />
              </button>
              <span className="tooltip">Add Digital Co-Reader</span>
            </div>

            <div className="tooltip-container w-20">
              <button
                className="py-1 text-white rounded bg-purple-800"
                // disabled={book.isCollection}
                disabled={true}
                onClick={() =>
                  handleDcrListClick(book.bookId, book.bookTitle)
                }
              >
                <FontAwesomeIcon icon={faUsers} />
              </button>
              <span className="tooltip">
                List of My Digital Co-readers for This Book
              </span>
            </div>
          </div>
          {flyOnTheWall && (
            <div className="flex justify-center">
              <Tooltip text={"Allow Fly On The Wall"} position={"top"}>
                <button
                  className="ml-2 py-1 text-white rounded bg-orange-500"
                  disabled={false}
                  style={{ maxWidth: "160px" }}
                >
                  <FontAwesomeIcon icon={faUserPlus} />
                  {/* Allow Fly On The Wall */}
                </button>
              </Tooltip>
              {/* <div className="tooltip-container w-20">
                                  <button
                                      className="py-1 text-white rounded bg-purple-800"
                                      onClick={() => handleDcrListClick(book.bookId, book.bookTitle)}
                                  >
                                      <FontAwesomeIcon icon={faUserPlus} />
                                  </button>
                                  <span className="tooltip">Allow Fly On The Wall</span>
                              </div> */}
              <Tooltip
                text={" Who All Are Flying On The Wall?!"}
                position={"top"}
              >
                <button
                  className="ml-2 py-1 text-white rounded bg-orange-500"
                  disabled={false}
                  style={{ maxWidth: "200px" }}
                >
                  <FontAwesomeIcon icon={faUserTie} />
                  {/* Who All Are Flying On The Wall?! */}
                </button>
              </Tooltip>
              {/* <div className="tooltip-container w-20">
                                  <button
                                      className="py-1 text-white rounded bg-purple-800"
                                      onClick={() => handleDcrListClick(book.bookId, book.bookTitle)}
                                  >
                                      <FontAwesomeIcon icon={faUserTie} />
                                  </button>
                                  <span className="tooltip">Who All Are Flying On The Wall?!</span>
                              </div> */}
            </div>
          )}
          {book.buyingMethod === "MLM" && (
            <div>
              <div>
                <div>
                  <p className="text-lg text-purple-700">
                    You are eligible for Multi Level Referral program. Under
                    this program you can earn active & passive income as per
                    following chart:{" "}
                  </p>
                </div>
                <div>
                  <button
                    className="py-1 text-white rounded bg-blue-700"
                    onClick={() => setShowTable(!showTable)}
                  >
                    Click here to see Multi-Level referral income chart
                  </button>
                  {/* {showTable && <MultiLevelReferralTable />} */}
                  {showTable && <BookEarningCalculator param={book.salesPrice} />}
                </div>
              </div>
              <div className="flex justify-center">
                <p className="text-lg text-green-600">
                  My Referrer:{" "}
                  <strong className="text-lg">{book.advisorName}</strong>
                </p>
              </div>
              <div className="mt-2 justify-center">
                <button
                  className="py-1 text-white rounded bg-purple-700"
                  onClick={() => {
                    handleMyReferralsListClick(
                      book.bookId,
                      book.userCode,
                      book.userLevel
                    );
                    toggleReferralsList();
                  }}
                >
                  {showReferrals 
                    ? "Hide Referrals List"
                    : "Show Referrals List"}
                </button>
                {/* {selectedBookId}{' data book '}{} */}
                {showReferrals && (
                  <div>
                    {myReferralsList.length === 0 && selectedBookId === book.bookId ? (
                      <p className="text-red-500">
                        There is No Referral Sales Yet for the book {book.bookTitle}!!
                      </p>
                    ) : (
                      myReferralsList.map((referral, index) => (
                        <>
                        {/* <div><p>Referral List for {book.bookTitle}</p></div> */}
                        { referral.userCode !== myUserCode && (
                          <div
                            key={index}
                            className="bg-gray-300 border-b text-blue-500 ml-4 mr-4 mb-1"
                          >
                            {/* <p className='text-blue-500'>SN: {index + 1}</p> */}
                            <p className="text-blue-500">
                              {index + 1}. User: {referral.userName} (
                              {referral.userCode})
                            </p>
                            {/* <p className='text-blue-500'>User Code: {referral.userCode}</p> */}
                            <p className="text-blue-500">
                              Purchase Date:{" "}
                              {new Date(
                                referral.purchaseDate
                              ).toLocaleDateString()}
                            </p>
                            <p className="text-blue-500">
                              Purchase Price: {referral.salesPrice.toFixed(2)}
                            </p>
                            {/* <p className='text-blue-500'>Level: {referral.userLevel}</p> */}
                          </div>
                        )}
                        </>
                      ))
                    )}
                  </div>
                )}
              </div>
              {/* <div className="mt-2 flex flex-col justify-center items-center text-white bg-gray-600">
                <p onClick={handleNewRefer} className="mt-4 text-lg text-white bg-purple-400">
                  Refer this book and earn Rs. {book.salesPrice * 0.2}
                </p>
                {newReferClicked && (
                  <>
                    <p>Email ID:</p>
                    <input
                      type="text"
                      name="newReferEmailId"
                      id="newReferEmailId"
                      value={newReferEmailId}
                      onChange={handleChange}
                      style={{
                        border: '1px solid #ccc',
                        padding: '2px',
                        backgroundColor: '#f0f0f0',
                        color: '#000000',
                        width: '200px',
                      }}
                    />
                    {fieldError("newReferEmailId")}
                    <p>WhatsApp Number:</p>
                    <input
                      type="text"
                      name="newReferContactNumber"
                      id="newReferContactNumber"
                      value={newReferContactNumber}
                      onChange={handleChange}
                      style={{
                        border: '1px solid #ccc',
                        padding: '2px',
                        backgroundColor: '#f0f0f0',
                        color: '#000000',
                        width: '100px',
                      }}
                    />
                    {fieldError("newReferContactNumber")}
                    <button
                      className="py-1 text-blue-800 rounded bg-yellow-200 w-40"
                      onClick={() =>
                        handleNewReferSent(book.bookId, newReferContactNumber, newReferEmailId)
                      }
                    >
                      Refer Now
                    </button>
                  </>
                )}
              </div> */}
              <div className="mt-2 justify-center">
                <button
                  className="py-1 text-white rounded bg-orange-500"
                  onClick={() => handleDownTheLineGetAllCount(book.bookId)}
                  disabled={downTheLineGetAllCountClicked}
                >
                  Show Lifetime Count
                </button>
                {downTheLineGetAllCountClicked && downTheLineGetCount && (
                  <div className="book-list-container ml-8 mt-2 text-red-800 overflow-x-auto">
                    <div className="overflow-x-auto">
                      <table className="responsive-table">
                        <thead className="bg-gray-800">
                          <tr>
                            <th className="py-3 px-4 uppercase font-semibold text-sm">
                              Level
                            </th>
                            <th className="py-3 px-4 uppercase font-semibold text-sm">
                              Members
                            </th>
                            <th className="py-3 px-4 uppercase font-semibold text-sm">
                              Commission
                            </th>
                          </tr>
                        </thead>
                        <tbody className="text-gray-700">
                          <tr>
                            <td className="py-3 px-4">Level 1</td>
                            <td className="py-3 px-4">
                              {downTheLineGetCount.l1.count-1}
                            </td>
                            <td className="py-3 px-4">
                              {parseFloat(
                                downTheLineGetCount.l1.totalCom-(book.salesPrice*0.2)
                              ).toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td className="py-3 px-4">Level 2</td>
                            <td className="py-3 px-4">
                              {downTheLineGetCount.l2.count}
                            </td>
                            <td className="py-3 px-4">
                              {parseFloat(
                                downTheLineGetCount.l2.totalCom
                              ).toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td className="py-3 px-4">Level 3</td>
                            <td className="py-3 px-4">
                              {downTheLineGetCount.l3.count}
                            </td>
                            <td className="py-3 px-4">
                              {parseFloat(
                                downTheLineGetCount.l3.totalCom
                              ).toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td className="py-3 px-4">Level 4</td>
                            <td className="py-3 px-4">
                              {downTheLineGetCount.l4.count}
                            </td>
                            <td className="py-3 px-4">
                              {parseFloat(
                                downTheLineGetCount.l4.totalCom
                              ).toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td className="py-3 px-4">Level 5</td>
                            <td className="py-3 px-4">
                              {downTheLineGetCount.l5.count}
                            </td>
                            <td className="py-3 px-4">
                              {parseFloat(
                                downTheLineGetCount.l5.totalCom
                              ).toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td className="py-3 px-4">Level 6</td>
                            <td className="py-3 px-4">
                              {downTheLineGetCount.l6.count}
                            </td>
                            <td className="py-3 px-4">
                              {parseFloat(
                                downTheLineGetCount.l6.totalCom
                              ).toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td className="py-3 px-4">Level 7</td>
                            <td className="py-3 px-4">
                              {downTheLineGetCount.l7.count}
                            </td>
                            <td className="py-3 px-4">
                              {parseFloat(
                                downTheLineGetCount.l7.totalCom
                              ).toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td className="py-3 px-4">Level 8</td>
                            <td className="py-3 px-4">
                              {downTheLineGetCount.l8.count}
                            </td>
                            <td className="py-3 px-4">
                              {parseFloat(
                                downTheLineGetCount.l8.totalCom
                              ).toFixed(2)}
                            </td>
                          </tr>
                          <tr className="bg-yellow-600">
                            <td className="py-3 px-4 font-semibold">Total</td>
                            <td className="py-3 px-4 font-semibold">
                              {totalCount-1}
                            </td>
                            <td className="py-3 px-4 font-semibold">
                              {(totalCommission-(book.salesPrice*0.2)).toFixed(2)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
              <div className="mt-2 justify-center">
                <button
                  className="py-1 text-white rounded bg-orange-500"
                  onClick={() => handleDownTheLineGetTodayCount(book.bookId)}
                  disabled={downTheLineGetTodayCountClicked}
                >
                  Show Yesterday's Count
                </button>
                {downTheLineGetTodayCountClicked && downTheLineGetCount && (
                  <div className="mt-4">
                    <p>
                      Level 1: {downTheLineGetCount.l1.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l1.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 2: {downTheLineGetCount.l2.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l2.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 3: {downTheLineGetCount.l3.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l3.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 4: {downTheLineGetCount.l4.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l4.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 5: {downTheLineGetCount.l5.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l5.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 6: {downTheLineGetCount.l6.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l6.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 7: {downTheLineGetCount.l7.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l7.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 8: {downTheLineGetCount.l8.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l8.totalCom).toFixed(2)}
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default SyntraMfgBookShelfListComponent;
